import { useTranslation } from "react-i18next";
import styled from "@emotion/styled";
import { Box } from "@mui/material";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import { DividendPerYear } from "@api";
import { DataBlockLayout } from "@rentablo/components";
import { DividendsKpiStrip } from "./DividendsKpiStrip";
import { useChartOptions } from "./useChartOptions";

const StyledContentBlock = styled(DataBlockLayout)({
  width: "100%",
});

interface Props {
  dividends?: DividendPerYear[];
  isFetching?: boolean;
}

export const DividendsBaseChart = ({ dividends, isFetching }: Props) => {
  const { t } = useTranslation();

  const title = t("fundamentals.metrics.dividendsPerYear.normal");
  const desc = t("fundamentals.metrics.dividendsPerYear.desc");

  const options = useChartOptions({ dividends });

  return (
    <StyledContentBlock
      title={title}
      isFetching={isFetching}
      toolTipData={{ desc1: desc }}
    >
      <DividendsKpiStrip dividends={dividends} />
      <Box pt={3} px={4} pb={2} width="100%">
        <HighchartsReact highcharts={Highcharts} options={options} />
      </Box>
    </StyledContentBlock>
  );
};
